import React from 'react'
import PropTypes from 'prop-types'

function DailyGreetingShell ({ classes, greetingText, subtitleNode }) {
  return (
    <div className={classes.container}>
      <div className={classes.greeting}>
        <span role='img' aria-label='wave' className={classes.wave}>
          {String.fromCodePoint(0x1f44b)}
        </span>
        <span>{greetingText}</span>
      </div>
      <div className={classes.subtitle}>{subtitleNode}</div>
    </div>
  )
}

DailyGreetingShell.propTypes = {
  classes: PropTypes.object.isRequired,
  greetingText: PropTypes.string.isRequired,
  subtitleNode: PropTypes.node.isRequired
}

export default DailyGreetingShell
